import { z } from 'zod';
import type { ApiContract } from '../contracts';

export const HealthResponseSchema = z.object({
  status: z.enum(['healthy', 'unhealthy']),
  timestamp: z.string(),
  database: z.object({
    connected: z.boolean(),
    latencyMs: z.number(),
  }),
});

export type HealthResponse = z.infer<typeof HealthResponseSchema>;

export const healthContract = {
  method: 'GET',
  path: '/api/health',
  response: HealthResponseSchema,
} as const satisfies ApiContract;
